<div class="watch-list">
	<app-watch-list-table
		[widget]="widget()"
		[marketStatus]="marketStatus()"
		[watchList]="watchList()"
		[isLoading]="isLoadingWatchList()"
		[statesColumns]="statesColumns()"
	/>
</div>
